import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Switch from 'react-switch'
import Analytics from '@cred/react-analytics'

class ReactSwitch extends Component {
  static propTypes = {
    analytics: PropTypes.object,
    onToggle: PropTypes.func.isRequired,
    name: PropTypes.string,
    label: PropTypes.string,
    checked: PropTypes.bool,
    analyticsContexts: PropTypes.array,
    analyticsOptions: PropTypes.object,
  }

  static defaultProps = {
    analytics: {},
    name: '',
    label: '',
    checked: false,
    analyticsContexts: [],
    analyticsOptions: null,
  }

  constructor(props) {
    super(props)

    this.analytics = new Analytics(props.analytics)
  }

  onChange = () => {
    const { onToggle, name, label, checked } = this.props

    this.analytics.event({
      name,
	    value: !checked ? 'checked' : 'unchecked',
	    label,
      error: null,
    })
    onToggle()
  }

  render() {
    const { analyticsContexts, analyticsOptions, ...props } = this.props

    return <Switch onChange={this.onChange} {...props} />
  }
}

export { ReactSwitch }

export default ReactSwitch
